import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Navigation.less';

const NavigationContent = props => (
  <div className={classNames('navigation-content', props.position, props.className)}>{props.children}</div>
);

NavigationContent.defaultProps = {
  position: '',
  className: '',
};

NavigationContent.propTypes = {
  position: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};

export default NavigationContent;



// WEBPACK FOOTER //
// ./src/components/ui/Navigation/NavigationContent.js